import { environment } from '../environments/environment';
import { NgGapiClientConfig } from 'ng-gapi';

export const gapiClientConfig: NgGapiClientConfig = {
    client_id: environment.clientId,
    ux_mode: 'popup',
    discoveryDocs: [''],
};
